var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPermission.si.view)?_c('div',[_c('md-tabs',{staticClass:"si-tab",attrs:{"md-sync-route":""}},[_c('md-tab',{attrs:{"id":"tab-si-header","md-label":"Header","to":"/si/headers"}}),_c('md-tab',{attrs:{"id":"tab-si-item","md-label":"Item","to":"/si/items"}})],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }